export var formatAddress = function (address) {
    if (!address)
        return '';
    var propertyName = address.propertyName, propertyNumber = address.propertyNumber;
    var propertyfirstline = propertyName != '' && propertyNumber != '' ? "".concat(propertyName, ", ").concat(propertyNumber) : propertyName || propertyNumber;
    return "".concat(propertyfirstline, ", ").concat(address.road, ", ").concat(address.town, ", ").concat(address.county, ", ").concat(address.postCode);
};
